module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/naspo/naspofront.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/naspo/naspofront.png
// module id = 599
// module chunks = 0